import { Committee, CommitteeSummary } from '@enview/interface/types/Committee';
import base, { ApiTag } from './base';

const buildJurisdictionParams = (juris: string | string[]): URLSearchParams => {
  const list = Array.isArray(juris) ? juris : [juris];

  // Sort for stable caching across different array orders
  const normalized = list
    .filter(Boolean)
    .map((s) => s.toLowerCase())
    .sort();

  const params = new URLSearchParams();
  normalized.forEach((abbr) => params.append('jurisdiction', abbr));
  return params;
};

const committeeAPI = base.injectEndpoints({
  endpoints: (build) => ({
    getCommittee: build.query<Committee, number>({
      query: (param) => ({ url: `/committees/${param}`, method: 'GET' }),
      providesTags: (result) => [{ type: ApiTag.COMMITTEE_TAG, id: result?.id }],
    }),
    getCommitteesByJurisdiction: build.query<Committee[], string | string[]>({
      query: (juris) => {
        const params = buildJurisdictionParams(juris);
        return {
          url: `/committees?${params.toString()}`,
          method: 'GET',
        };
      },
    }),
    // Excludes memberships, which are only needed when listing committee members
    getCommitteeSummariesByJurisdiction: build.query<CommitteeSummary[], string[]>({
      query: (juris) => {
        const params = buildJurisdictionParams(juris);
        params.append('withMemberships', 'false');
        return {
          url: `/committees?${params.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
  overrideExisting: false,
});
export default committeeAPI;
